import React, { ReactNode } from 'react';
import {
  createReducer,
  createStore,
  Provider as PRProvider,
} from 'react-principal';
import { persistkeys } from '../constants';
import AsyncStorage from '@react-native-async-storage/async-storage';

const SET_ALERT = 'SET_ALERT';
// const CLEAR = 'CLEAR';

interface InitialState {
  alert: number;
}

const initialState: InitialState = {
  alert: 0,
};

const reducer = createReducer<InitialState>({
  SET_ALERT: (state, { payload: { alert } }) => ({
    ...state,
    alert,
  }),
  // CLEAR: (state, {}) => ({
  //   ...state,
  //   token: '',
  // }),
});

function setAlert(alert: number) {
  return {
    type: SET_ALERT,
    payload: { alert },
  };
}

// function logOut() {
//   return {
//     type: CLEAR,
//     payload: {},
//   };
// }

const storeAlert = createStore({
  reducer,
  initialState,
  persistKey: persistkeys.alert,
  storage: AsyncStorage,
  mapStateToPersist: ({ alert }) => ({
    alert,
  }),
});

const mapAlertPersistToState = () => storeAlert.setToState();

const getAlertFromPersist = () => storeAlert.state.alert;

const AlertProvider = ({ children }: { children: ReactNode }) => {
  return <PRProvider {...{ store: storeAlert }}>{children}</PRProvider>;
};

export {
  initialState as initialStateAlert,
  reducer as reducerAlert,
  setAlert,
  AlertProvider,
  storeAlert,
  mapAlertPersistToState,
  getAlertFromPersist,
};
